import {request, serviceUrl} from "@/utils/request";

// 获取菜单
export function getResourceList() {
  return request({
    url: serviceUrl.iamService + '/app/resource/list',
    params: {
      clientId: window.g.clientId
    }
  })
}

// 获取当前用户的权限码
export function getPermission() {
  return request({
    url: serviceUrl.iamService + '/app/resource/getPermission'
  })
}
